module.exports = __webpack_public_path__ + "static/Cooladata-4649b76ead942f48bd690496f59465ce.png";